import React, { memo, useMemo } from 'react'

import ColorPickerPopover from '@components/ColorPickerPopover'

import { CUSTOM_TAG_AVAILABLE_COLORS } from '../../constants'
import { CustomTag } from '../../types'

export interface TagColorPickerPopoverProps {
  existingTags: CustomTag[]
  anchorEl?: HTMLElement
  tag: CustomTag
  onColorPicked: (color?: string) => void
}

const TagColorPickerPopover = ({ existingTags, anchorEl, tag, onColorPicked }: TagColorPickerPopoverProps) => {
  const selectedColor = tag.color
  const availableColors = useMemo(
    () =>
      CUSTOM_TAG_AVAILABLE_COLORS.filter(color =>
        existingTags.every(existingTag => tag === existingTag || color.toLowerCase() !== existingTag.color.toLowerCase()),
      ),
    [existingTags, tag],
  )

  return (
    <ColorPickerPopover
      colors={availableColors}
      selectedColor={selectedColor}
      anchorEl={anchorEl}
      onColorPicked={onColorPicked}
    />
  )
}

export default memo(TagColorPickerPopover)
